/* eslint-disable complexity */
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Button from 'carbon-react/lib/components/button';

import { FormattedMessage } from '@futrli/localisation';
import { getReportingUrl } from '@futrli/shared-services';

import { ScheduleReportDialog } from '../schedule-report-dialog/schedule-report-dialog';
import { ScheduleReportItem } from './schedule-report-item';
import { SendEmailDialog } from '../../../ui/virtualized-list/document-library/sent-email-dialog';
import { usePredictionsInfoContext } from '../../../forecast/detail/context/predictions-info-context';
import { useReportBuilderContext } from '../../report-builder.context';
import { useReportsContext } from '../../reports.context';

import * as styles from './schedule-panel.scss';

export const SchedulePanel = () => {
  const [isOpenSendEmailDialog, setIsOpenSendEmailDialog] = useState(false);
  const [isOpenScheduleDialog, setIsOpenScheduleDialog] = useState(false);

  const { reports } = useReportsContext();

  const {
    reportId,
    scheduledReports,
    dispatchedReports,
    isViewPage,
    revalidateScheduleReportData
  } = useReportBuilderContext();

  const navigate = useNavigate();

  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisationId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisationId || '';
  const { isConsolidation } = usePredictionsInfoContext();

  const noScheduleReports = typeof scheduledReports !== 'undefined' && scheduledReports.length === 0;
  const noAwaitingReviewReports = typeof dispatchedReports !== 'undefined' && dispatchedReports.length === 0;
  const noReports = noScheduleReports && noAwaitingReviewReports;

  const report = reports.find(r => r.id === reportId);

  const handleOpenEmailDialog = () => setIsOpenSendEmailDialog(true);

  const handleCloseEmailDialog = () => setIsOpenSendEmailDialog(false);

  const handleScheduleClick = () => setIsOpenScheduleDialog(true);

  const handleCloseScheduleDialog = () => setIsOpenScheduleDialog(false);

  const handleExit = () => {
    navigate(getReportingUrl(workspaceId, organisationId, isConsolidation));
  };

  return (
    <div>
      <div style={{ display: 'flex' }}>
        <Button mr={1} buttonType="primary" size="small" onClick={handleOpenEmailDialog}>
          <FormattedMessage id="reporting.send_pdf_now" defaultMessage="Send PDF of report now" />
        </Button>
        {isViewPage && (
          <Button size="small" buttonType="secondary" onClick={handleExit}>
            <FormattedMessage id="common.exit" defaultMessage="Exit" />
          </Button>
        )}
      </div>

      <div className={styles.title} style={{ marginTop: 20 }}>
        <FormattedMessage id="reporting.schedules_running" defaultMessage="Schedules running" />
      </div>
      <Button size="small" mt={1} buttonType="secondary" onClick={handleScheduleClick}>
        <FormattedMessage id="reporting.new_schedule" defaultMessage="New schedule" />
      </Button>
      <div style={{ marginTop: 20 }}>
        {noReports ? (
          <FormattedMessage
            id="reporting.no_pdf_schedules_for_report"
            defaultMessage="You have no PDF schedules running for this report."
          />
        ) : (
          <>
            {dispatchedReports?.map(r => (
              <ScheduleReportItem isAwaitingReview key={r.id} scheduleReport={r} reportId={report?.id || ''} />
            ))}
            {scheduledReports?.map(r => (
              <ScheduleReportItem key={r.id} scheduleReport={r} reportId={report?.id || ''} />
            ))}
          </>
        )}
        <div style={{ height: 20 }} />
      </div>
      {isOpenSendEmailDialog && (
        <SendEmailDialog
          isOpen={isOpenSendEmailDialog}
          handleClose={handleCloseEmailDialog}
          reportName={report?.name}
          reportId={report?.id}
          revalidateData={revalidateScheduleReportData}
        />
      )}

      {isOpenScheduleDialog && (
        <ScheduleReportDialog
          isOpen={isOpenScheduleDialog}
          handleClose={handleCloseScheduleDialog}
          revalidateData={revalidateScheduleReportData}
          reportName={report?.name}
          reportId={report?.id || ''}
        />
      )}
    </div>
  );
};
